import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=559f45c2&scoped=true"
import script from "./addForm.vue?vue&type=script&lang=js"
export * from "./addForm.vue?vue&type=script&lang=js"
import style0 from "./addForm.vue?vue&type=style&index=0&id=559f45c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f45c2",
  null
  
)

export default component.exports